module.exports = __webpack_public_path__ + "1708654020752/assets/img/wasteland.25a4a580.png";